import styled, { css } from 'styled-components';
import facebook from '../../assets/images/facebook_icon.svg?react';
import twitter from '../../assets/images/twitter_icon.svg?react';
import linkedin from '../../assets/images/linkedin_icon.svg?react';
import instagram from '../../assets/images/instagram_icon.svg?react';

export const Social = styled.nav`
  border-radius: 0.5rem;
  margin: 0rem 0.625rem;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  a {
    background: transparent;
    text-decoration: none;
    border-radius: 0.313rem;
    img {
      border-radius: 0.313rem;
      transition: box-shadow 0.2s ease-in-out;
      &:hover {
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.5);
      }
    }
    svg {
      border-radius: 0.313rem;
      transition: box-shadow 0.2s ease-in-out;
      &:hover {
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.5);
      }
    }
    path {
      fill: ${({ theme }) => theme.colors.sideBarColorSteps};
    }
  }
`;

const baseSocialIconStyles = css`
  width: 2rem;
  height: 2rem;
  margin: 0;
  padding: 0;
  &:hover {
    path {
      fill: ${(props) => props.theme.colors.socialIconsHoverColor || props.theme.colors.sideBarColorSteps};
    }
  }
`;

export const LinkedinLogo = styled(linkedin)`
  ${baseSocialIconStyles}
`;

export const FacebookLogo = styled(facebook)`
  ${baseSocialIconStyles}
`;

export const TwitterLogo = styled(twitter)`
  ${baseSocialIconStyles}
`;

export const InstagramLogo = styled(instagram)`
  ${baseSocialIconStyles}
`;
